import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import ContactAvatar from '../../../../../components/ContactAvatar';
import Translate from '../../../../../components/Translate';
import SendAndCancelButton from '../../../../../components/ProceedAndExitButtons';
import config from "../../../../../config";
import Pending from "../../../../../assets/images/pending.png"
import ColorIndicator from "../../../../../components-new/ColorIndicator";

const dialogStyles = {
    modalStyle: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            border: 'none',
            padding: '40px',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '500px',
            borderRadius: '20px'
        },
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            zIndex: '2000',
        },
    },
    header: {
        fontSize: '18px',
        color: '#09183A',
        paddingBottom: '20px',
        textAlign: 'center'
    },
    modalContent: {
        // display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    list: {
        width: '100%',
        maxHeight: '300px',
        overflow: 'auto',
        padding: '20px 0px',
        cursor: 'pointer'
    },
    listItemWrapper: {
        padding: '10px',
        borderBottom: '1px solid #F2F5FC'
    },
    listItemWrapper2: {
        padding: '10px',
    },
    selectedListItem: {
        padding: '10px',
        backgroundColor: 'rgb(233, 247, 248)',
        borderBottom: '1px solid #F2F5FC'
    },
    selectedListItem2: {
        padding: '10px',
        backgroundColor: 'rgb(233, 247, 248)',
        borderBottom: '1px solid #F2F5FC'
    },
    listItem: {
        maxWidth: '380px',
        marginLeft: '10px',
        fontSize: '16px',
    },
    inputSubject: {
        width: '100%',
        padding: '10px',
        marginTop: '10px',
        borderRadius: '10px',
        border: '1px solid #c3c3c3',
    },
    textareaDescription: {
        width: '100%',
        padding: '10px',
        marginTop: '10px',
        borderRadius: '10px',
        border: '1px solid #c3c3c3',
        resize: 'none',
        height: '80px',
    }
};

const ForwardDialog = ({state, close, contactClick, contactList, dialogMode, user, conv}) => {
    const [selectedId, setSelectedId] = useState(null);
    const [silentMod, setSilentMod] = useState(false);

    const handleContact = (contact) => {
        setSelectedId(contact.id);
    };

    const handleUnmanagedListClick = () => {
        setSelectedId("-1");
    }

    const handleSelection = () => {
        if (selectedId === "-1") {
            contactClick("-1", silentMod, conv);
            close();
            return
        }
        let found = contactList.find(contact => contact.id === selectedId);
        if (selectedId === user.id) {
            found = user
        }
        contactClick(found, silentMod, conv);
        close()
    };

    const handleInputChange = (event) => {
        setSilentMod(event.target.checked)
    };

    return (
        <Modal closeTimeoutMS={config.closeTimeoutMS} style={dialogStyles.modalStyle} isOpen={state.isOpen}
               onRequestClose={close}>
            <div style={dialogStyles.modalContent}>
                <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                    <h2 className={'title_feedback'}>
                        <Translate text="forward"/>
                    </h2>
                    <h5
                        style={{
                            fontSize: '11px',
                            marginBottom: '10px',
                            marginLeft: '20px'
                        }}
                    ><Translate text="forwardInfo"/></h5>
                </div>
            </div>
            <ul id="forward-agent-list" style={dialogStyles.list} className="list">
                <li
                    key={'-1'}
                    style={'-1' === selectedId ? dialogStyles.selectedListItem2 : dialogStyles.listItemWrapper2}
                    onClick={() => handleUnmanagedListClick()}
                    className="contact-list-item">
                    <button
                        type="button"
                        className="no-style-button centered-flex-container"
                        style={{padding: '0'}}
                    >
                        <img style={{marginLeft: '1px'}} src={Pending} width={25} height={25}/>
                        <span
                            className="hide-text-overflow"
                            style={{
                                ...dialogStyles.listItem,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                marginLeft: '21px'
                            }}
                        >
                            <Translate text={'unmanagedList'}/>
                        </span>
                    </button>
                </li>
                <li
                    key={user.id}
                    style={user.id === selectedId ? dialogStyles.selectedListItem2 : dialogStyles.listItemWrapper2}
                    onClick={() => handleContact(user)}
                    className="contact-list-item">
                    <button
                        type="button"
                        className="no-style-button centered-flex-container"
                        style={{padding: '0'}}
                    >
                        <ContactAvatar contact={user} inMenu={true}/>
                        <span
                            className="hide-text-overflow"
                            style={{
                                ...dialogStyles.listItem,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                marginLeft: '21px'
                            }}
                        >
                            {`${user.firstName} ${user.lastName}`} (<Translate text={'you'}/>)
                        </span>
                    </button>
                </li>
                {contactList && contactList.map((contact) => {
                    const firstName = contact.firstName ? contact.firstName : '';
                    const lastName = contact.lastName ? contact.lastName : '';
                    return (
                        <li
                            key={contact.id}
                            style={contact.id === selectedId ? dialogStyles.selectedListItem : dialogStyles.listItemWrapper}
                            onClick={() => handleContact(contact)}
                            className="contact-list-item">
                            <button
                                type="button"
                                className="no-style-button centered-flex-container"
                                style={{padding: '0'}}
                            >
                                <ContactAvatar contact={contact} inMenu={true}/>
                                <span
                                    className="hide-text-overflow"
                                    style={{
                                        ...dialogStyles.listItem,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px'
                                    }}
                                >
                                    <div style={{display: 'flex', gap: '5px', alignItems: 'center', marginLeft: '10px'}}>
                                       <ColorIndicator currentStatus={contact.currentStatus}/>
                                    </div>
                                    {`${firstName} ${lastName}`}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>

            <div style={{marginBottom: '15px'}}>
                <label className="checkbox_label" style={{
                    display: 'block', fontSize: '14px'
                }}>
                    <input
                        type="checkbox"
                        name="silentModForward"
                        checked={silentMod}
                        onChange={(e) => handleInputChange(e)}
                    />
                    <Translate text="silentModForward"/>
                </label>
            </div>

            <SendAndCancelButton
                disabled={!selectedId}
                id="forward-agent-button"
                className="forward-agent-button"
                handleProceed={handleSelection}
                handleExit={close}
                proceedText={<Translate text="send"/>}
                cancelText={<Translate text="cancel"/>}
                exitText="cancel"
                exitAction={close}
                proceedAction={handleSelection}
            />
        </Modal>
    );
};

ForwardDialog.propTypes = {
    state: PropTypes.object,
    close: PropTypes.func,
    contactList: PropTypes.array,
    contactClick: PropTypes.func,
    // dialogMode: PropTypes.string.isRequired,
};


export default ForwardDialog;




// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/ForwardDialog.jsx